document.querySelectorAll('[data-gift-bundle]').forEach((bundle) => {
  const checkbox = bundle.querySelector('[data-gift-bundle-checkbox]');
  const totalRow = bundle.querySelector('[data-gift-bundle-total-row]');
  const totalValue = bundle.querySelector('[data-gift-bundle-total]');
  const addonCents = parseInt(bundle.dataset.addonCents, 10);
  const priceTarget = document.getElementById(bundle.dataset.priceTarget);

  const readBasePriceCents = () => {
    const text = priceTarget ? priceTarget.textContent : '';
    const match = text.match(/[\d,]+\.\d{2}/);
    if (!match) return null;
    return Math.round(parseFloat(match[0].replace(/,/g, '')) * 100);
  };

  const formatCents = (cents) => {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
    } catch (error) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const updateTotal = () => {
    if (!checkbox.checked) {
      totalRow.hidden = true;
      return;
    }

    const baseCents = readBasePriceCents();
    if (baseCents === null) {
      totalRow.hidden = true;
      return;
    }

    totalValue.textContent = formatCents(baseCents + addonCents);
    totalRow.hidden = false;
  };

  checkbox.addEventListener('change', updateTotal);

  if (priceTarget && 'MutationObserver' in window) {
    new MutationObserver(updateTotal).observe(priceTarget, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  const form = document.getElementById(bundle.dataset.formId);
  if (!form) return;

  document.addEventListener(
    'submit',
    (event) => {
      if (event.target !== form || !checkbox.checked) return;

      event.preventDefault();
      event.stopPropagation();

      const variantInput = form.querySelector('[name="id"]');
      const quantityInput = form.querySelector('[name="quantity"]');
      const mainVariantId = variantInput ? variantInput.value : null;
      const mainQuantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      if (!mainVariantId) return;

      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = {
        items: [
          { id: parseInt(mainVariantId, 10), quantity: mainQuantity },
          { id: parseInt(bundle.dataset.serumVariantId, 10), quantity: 1 },
          { id: parseInt(bundle.dataset.rollerVariantId, 10), quantity: 1 },
        ],
      };

      if (cart) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        cart.setActiveElement?.(document.activeElement);
      }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) throw new Error(response.description || response.message);

          if (cart) {
            cart.renderContents(response);
            if (submitButton) submitButton.disabled = false;
            window.publish?.(window.PUB_SUB_EVENTS?.cartUpdate, {
              source: 'gift-bundle-upsell',
              cartData: response,
            });
          } else {
            window.location.href = window.routes.cart_url;
          }
        })
        .catch(() => {
          if (submitButton) submitButton.disabled = false;
          const errorWrapper = form.querySelector('.product-form__error-message-wrapper');
          const errorMessage = form.querySelector('.product-form__error-message');
          if (errorWrapper && errorMessage) {
            errorMessage.textContent = 'Something went wrong adding the gift set. Please try again.';
            errorWrapper.hidden = false;
          }
        });
    },
    true
  );
});
